<template>
  <div
    :grc_placeholder="placeholder"
    :grc_labeltext="labeltext"
    :grc_labelmode="labelmode"
    :grc_labelwidth="labelwidth"
    :grc_readonly="readonly"
    :grc_ispassword="ispassword"    
    :grc_canshowpassword="canshowpassword"    
    :grc_autocomplete="autocomplete" 

    :value="component_value"
  >
    <div ref="comp_container" :class="['grccomp_container', labelmode=='table' ? 'grccomp_container_tablemode' : '']">
      <div ref="container_label" v-html="labeltext" @click="onLabelClick"
        :class="['grccomp_container_label', labelmode=='nolabel' ? 'grccomp_container_nolabel' : '', comp_focused ? 'grccomp_container_label_focused' : '']"
        v-bind:style="{ 'width': labelwidth }"
      ></div>

      <div ref="container_input" class="grccomp_container_input" style="position:relative;">
        <input ref="textinput" inputmode="email"
        :type="ShowText ? 'text' : 'password'" 
        :class="['grc-input', ispassword ? 'grc-input-password':'']"
        :autocomplete="autocomplete"
        :name="compname"
        v-model="display_text" 
        @input="onInput" 
        @blur="onInputBlur" 
        @focus="onInputFocus($event)" 
        @keydown="onInputKeydown"
        :readonly="readonly == 'true'"
        v-bind:placeholder="placeholder"
         />

        <div class="grc-input-password-eye-cont" v-show="(ispassword=='true')&&(canshowpassword=='true')" @click="ToggleTextPwd">
          <span v-show="ShowText==false"><i class="fa-light fa-eye"></i></span>
          <span v-show="ShowText==true"><i class="fa-light fa-eye-slash"></i></span>
        </div>

      </div>
    </div>

    <GrcCompErrorBubble ref="ErrorBubble" />
  </div>
</template>

<script>

import Vue from 'vue'
import GrcCompErrorBubble from '../GrcComponents/GrcCompErrorBubble.vue'

export default {
  name: 'GrcText',
  components:
  {
    GrcCompErrorBubble

  },
  props: {
    value: String,
    grc_placeholder: String,
    grc_labeltext: String,
    grc_labelmode: String,
    grc_labelwidth: String,
    grc_readonly: String,
    grc_ispassword: String,
    grc_canshowpassword: String,
    grc_autocomplete: String
  },
  data () {
    return {
        component_value: "",
        prev_component_value: "",

        display_text: "",
        prev_display_text: "",         

        placeholder: this.grc_placeholder,
        labeltext: this.grc_labeltext,
        labelmode: this.grc_labelmode,
        labelwidth: this.grc_labelwidth,
        readonly: this.grc_readonly,
        ispassword: this.grc_ispassword,
        canshowpassword: this.grc_canshowpassword,
        autocomplete: this.grc_autocomplete,
        compname:"",

        comp_focused: false,

        value_on_focus: "",

        ShowText: true,
    }
  },
  watch : {
    value (pNewValue) {
      if (pNewValue !== this.prev_component_value) {
          this.prev_component_value = pNewValue;
          this.component_value = pNewValue;
          this.DisplayValue(pNewValue);
      }
    },

    display_text()
    {
        if (this.comp_focused == false) { return; }
        if (this.display_text != this.prev_display_text)
        {
            if (this.CheckText(this.display_text) == false)
            {
                this.display_text = this.prev_display_text;
            }
            else
            {
                this.prev_display_text = this.display_text;

                this.$emit('grc-innervaluechanged', this.display_text);

            }
        }
    }
  },

  created: function()
  {
    if (typeof this.autocomplete == "undefined")
    {
      this.autocomplete = "none";
    }

    if (this.autocomplete != "on")
    {
      this.compname = "cn"+Math.random();
    }

    if (typeof this.labelmode == "undefined")
    {
      this.labelmode = "nolabel";
    }

    var labelmodes = ["table", "above", "nolabel"];
    if (labelmodes.includes(this.labelmode) == false)
    {
      this.labelmode = "above";
    }

    if (typeof this.labelwidth == "undefined")
    {
      this.labelwidth = "";
    }


    if (typeof this.placeholder == "undefined")
    {
      this.placeholder = "";
    }


    if (typeof this.canshowpassword == "undefined")
    {
      this.canshowpassword = "false";
    }

    if (typeof this.value != "undefined")
    {
      this.prev_component_value = this.value;
      this.component_value = this.value;
      this.DisplayValue(this.component_value);
    }
    
    this.ShowText = true;
    
    if (this.ispassword == "true") { this.ShowText = false; }


    if (this.canshowpassword == "mobilapp")
    {
      this.canshowpassword = "true";
    }


  },
  computed: {
  },
  methods: {

    ToggleTextPwd()
    {
      this.ShowText = !(this.ShowText);
    },

    onLabelClick()
    {
      this.$emit('grc-labelclick');
    },

    SetLabel(pText)
    {
      this.labeltext = pText;
    },

    ShowError(pText)
    {
      this.$refs.ErrorBubble.ShowError(pText);
    },

    HideError()
    {
      this.$refs.ErrorBubble.HideError();
    },

    DisplayValue(pNewValule)
    {
        var s = this.FormatText(pNewValule);

        this.prev_display_text = s;
        this.display_text = s;
    },

    CheckText: function(pText)
    {
      var CheckOK = true;
      
      return CheckOK;
    },

    FormatText: function(pText)
    {
      if (pText == null) { pText = ""; }

      return pText;
    },

    onInputBlur()
    {
      if (this.IsReadonly()) 
      {
        this.$emit('grc-blur');
        return;
      }

      var s = this.FormatText(this.display_text);
      this.component_value = s;

      var ValueChanged = (this.component_value != this.value_on_focus);
      //console.log("v: "+this.component_value+"  vonf: "+this.value_on_focus);


      

      this.comp_focused = false;

      if (ValueChanged)
      {
        this.$emit('valuechanged', this.component_value);
      }
      else
      {
        this.prev_component_value = this.component_value;
        this.DisplayValue(this.component_value);          
      }

      this.$emit('grc-blur');
      this.$emit('input', this.component_value);

    },


    onInput (e) {
      //if (e.isTrusted) { return; } // ignore native event
    },

    onInputKeydown(e)
    {
      if ((e.keyCode == 13) || (e.keyCode == 9)) {}
      else
      {
        this.$refs.ErrorBubble.HideError();
      }

      this.$emit('grc-keydown', e.keyCode);

      if (e.keyCode == 13)
      {
        this.$emit('grc-keydown-enter');
      }
    },

    onInputFocus(e)
    {
      this.comp_focused = true;
      this.value_on_focus = this.component_value;
      this.DisplayValue(this.component_value);
        Vue.nextTick(function () {
            //e.target.select();
            //e.target.setSelectionRange(0, 0);
        });      
      this.$emit('grc-focus');

      /*
      if (this.IsReadonly() == false)
      {
        if (gMobilDeviceInfo.Platform == "android")
        {
          var ss = grccomp_getScreenSize().height / 4;

          var elpos = grccomp_findPos(this.$refs.textinput);
          elpos.top = elpos.top-ss-20;
          if (elpos.top < 0) { elpos.top = 0; }
          window.scrollTo(0, elpos.top);
        }
      }
      */

    },

    SetFocus()
    {
      this.$refs.textinput.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    },

    SetText(pText)
    {
      this.prev_component_value = pText;
      this.component_value = pText;
      this.DisplayValue(pText);
      this.$emit('input', this.component_value);
    },

    GetText()
    {
      return this.component_value;
    },


    GetInnerText()
    {
      return this.display_text;
    }

    
  }
}
</script>

